import { Component, OnInit} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { VariablesService } from '../../services/variables.service';
import _ from 'lodash';

@Component({
    templateUrl: './testpage.component.html',
    standalone: false
})
export class TestPageComponent implements OnInit {
  isSubmitting = false;
  isError = false;
  attendee;
  pax;
  prefixList;
  suffixList;
  cdsid;
  noncompid;
  workPhone;
  testPageRadios
  attendeetypetest
  homePhone;
  mobilePhone;
  workAddress;
  homeAddress;
  emailAddress;
  adminContact;
  emerContact;
  emerContactMainPhone;
  emerContactAltPhone;
  DisabilityType;
  mealList;
  personalConsiderationsList;
  $mtcverifyEmailAddress;
  $mtcMailToAddress;
  $mtcHasConsiderations;
  isRegComplete;
  enrollment;
  answer;
  isFormCompleted = false;

  clickedCountry;
  childEventClicked(data) {
    this.clickedCountry = data;
  }


  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private variablesService: VariablesService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.attendee = this.registrationService.getAttendee({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    this.testPageRadios = [
        {value: 1, display: "Customer 1 (Fleet)"},
        {value: 2, display: "Customer 2 (Upfitter)"},
        {value: 3, display: "Customer 3 (Dealer)"},
        {value: 4, display: "Customer 5 (Government)"},
        {value: 5, display: "Company"},
        {value: 6, display: "Non-Company - Supplier"},
        {value: 7, display: "Production"}
    ];
  
    this.pax = this.attendee.PAXTypeNo;

  }

  ngOnInit(): void { 


  }

  includes(arr, val){
    return _.includes(arr, val);
  }

  keepLoginVariables(){
    let loginVars=[
      'partsAcctNo',
      'region',
      'NAM',
      'NAMEmail',
      'FINNumber',
      'requestor',
      'team',
      'RSM',
      'languaje',
      'cdsid'
    ];
    let paxVar=[];
    this.attendee.PAXVariableData.forEach(paxV=>{
      //let isLoginVar=loginVars.forEach
      if(
        paxV.hasOwnProperty('WebSequenceNo') && 
        loginVars.find((el)=>this.variablesService.VARIABLE[el].ID==paxV.WebSequenceNo)
        ){
          paxVar.push({...paxV});
        }
    });

    return paxVar;

  }


  cleanAttendee(){
    let LoginVariables= this.keepLoginVariables(); // login variables to keep
    // Removing all pax variables
    this.attendee.PAXVariableData.forEach(paxV=>{
      if(paxV.hasOwnProperty('Value')) delete paxV.Value;
    });
    //removing other values on attendee and enrollment
    let toDelete={
      "attendee":[
        "$mtcDisplayName",
        "$mtcHasGuestsAttending",
        "$mtcOutbound",
        "$mtcReturn",
        "$mtcvarCountryOfRes",
        "TravelType"
      ],
      "enrollment":[
        "$mtcHasAdminContact",
        "$mtcHasGuestAgeAcknowledged",
        "HotelNeeded",
        "HotelCheckInDate",
        "HotelCheckOutDate"
      ]
    }
    
    Object.keys(toDelete).forEach(el=>{
      if(this[el]){
        let nested = this[el];
        toDelete[el].forEach(subprop=>{
          if(nested.hasOwnProperty(subprop)) nested[subprop]="";
        });
      }
    });
    //restoring login variables
    this.attendee.PAXVariableData=LoginVariables;

  }






  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;
 
    if (form.valid ) {
      this.cleanAttendee();
      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;

    }
  }

  back() {
    this.navigationService.back();
  }
}
